module.exports = __webpack_public_path__ + "img/slider-3.6a8958ac.png";